
import en from'@24i/prd-localization-files-prj-voa/dist/en.json';
import bo from'@24i/prd-localization-files-prj-voa/dist/bo.json';
import th from'@24i/prd-localization-files-prj-voa/dist/th.json';
import tr from'@24i/prd-localization-files-prj-voa/dist/tr.json';
import ps from'@24i/prd-localization-files-prj-voa/dist/ps.json';
import prs from'@24i/prd-localization-files-prj-voa/dist/prs.json';
import my from'@24i/prd-localization-files-prj-voa/dist/my.json';
import uk from'@24i/prd-localization-files-prj-voa/dist/uk.json';
import id from'@24i/prd-localization-files-prj-voa/dist/id.json';
import ur from'@24i/prd-localization-files-prj-voa/dist/ur.json';
import ko from'@24i/prd-localization-files-prj-voa/dist/ko.json';
import fa from'@24i/prd-localization-files-prj-voa/dist/fa.json';
import zh from'@24i/prd-localization-files-prj-voa/dist/zh.json';
import es from'@24i/prd-localization-files-prj-voa/dist/es.json';
import ru from'@24i/prd-localization-files-prj-voa/dist/ru.json';

export var i18nOptions={
resources:{
en:{sott:en},
bo:{sott:bo},
th:{sott:th},
tr:{sott:tr},
ps:{sott:ps},
prs:{sott:prs},
my:{sott:my},
uk:{sott:uk},
id:{sott:id},
ur:{sott:ur},
ko:{sott:ko},
fa:{sott:fa},
zh:{sott:zh},
es:{sott:es},
ru:{sott:ru}
}
};